var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vc-date-picker',{ref:"calendar",attrs:{"mode":_vm.selectMode,"attributes":_vm.attributes,"is-inline":"","min-date":_vm.minDate,"value":_vm.reserva.disponibilidad,"disabled-dates":_vm.disabledDates,"id":"CalendarioComponente","locale":_vm.language},on:{"dayclick":_vm.singleClickSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }